import { render } from "./cms-bi-text.vue?vue&type=template&id=bd35aa48"
import script from "./cms-bi-text.vue?vue&type=script&lang=js"
export * from "./cms-bi-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__